import { Injector } from "@angular/core";
import { BaseNode } from "./BaseNode";
import { ServiceEnum } from "../ServiceEnum";
import { MedicinalproductsService } from "../../service/medicinalproducts-service/medicinalproducts.service";
import { Art57Section } from "../Art57Section/Art57Section";
import { environment } from "../../../../environments/environment";
import { DummyNode } from "./DummyNode";
import { FormlyView } from "../Data/FormlyView";
import { Art57Node } from "./Art57Node/Art57Node";
import { SectionService } from "../../service/section-service/section-service";

export class AutoUploadNode extends BaseNode {
    entityClass?: new (...args: any[]) => Art57Node;
    autoUploadEntityName?: string;
    code?: string;
    service?: string;
    isLoaded: boolean = false;
    isLoading: boolean = false;
    createDummyNode: boolean = false;
    cloningNode: boolean = false;
    parentNodeClass?: new (...args: any[]) => BaseNode;
    createChildTemplateParams?: any;
    disableAutoUpload: boolean;
    datasource:any;
    initialModel:any;

    constructor(injector: Injector, labelTemplate: string, entityClass: new (...args: any[]) => any, autoUploadEntityName: string, service: string, parent: BaseNode, model: any, parentNodeClass: (new (...args: any[]) => BaseNode)|undefined, createDummyNode: boolean, disableAutoUpload: boolean, cloningNode: boolean, createChildTemplateParams?: any) {
        super(injector, new FormlyView(), labelTemplate);
        this.parent = parent;
        this.entityClass = entityClass;
        this.data.model = model;
        this.autoUploadEntityName = autoUploadEntityName;
        this.datasource = {...model};
        this.initialModel = {...model};
        this.code = model.id;
        this.service = service;
        this.parentNodeClass = parentNodeClass;
        this.createChildTemplateParams = createChildTemplateParams;
        this.createDummyNode = createDummyNode;
        this.disableAutoUpload = disableAutoUpload;
        this.cloningNode = cloningNode;
        
        if (this.createDummyNode) {
            this.children?.push(new DummyNode());
        }
        this.ioc!.get(Art57Section).generateNumColumValue(this);

        this.refreshLabel();
    }

    postLoadEntity(model: any) {

    }

    loadEntity() {

        if (this.isLoaded) {
            return;
        }

        if (this.disableAutoUpload) {
            this.children?.splice(0, this.children.length); // remove dummy node
            this.data = new this.entityClass!(this.ioc!, this.data.model);
            if (!this.cloningNode){
                this.postLoadEntity(this.datasource);
            }
            this.isLoaded = true;
        } else {
            let service: any;
            switch (this.service) {
                case ServiceEnum.MedicinalProducts:

                    service = this.ioc!.get(MedicinalproductsService);
            }

            if ((!this.isLoaded) && (!this.isLoading)) {
                this.isLoading = true;
                this.children?.splice(0, this.children.length); // remove dummy node
                service.loadEntity(this.autoUploadEntityName, this.code)
                    .subscribe({
                        next: (data: any) => {
                            const jsonData = data;
                            if (jsonData) {
                                this.data = new this.entityClass!(this.ioc!, jsonData);
                                this.datasource = jsonData;
                                this.postLoadEntity(jsonData);
                                this.refreshLabels();
                                this.isLoaded = true;
                                this.ioc!.get(MedicinalproductsService).loading.next(false);
                            } else {
                                this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'warn', detail: 'No results found', life: environment.warningElapsedTime });
                            }
                        },
                        error: (error: any) => {
                            this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'error', detail: 'Error found', life: environment.errorElapsedTime });
                        }
                    });
            }
        }
    }

    refreshLabels() {
        if (this.constructor.name === "_AuthorisedProductAutoUploadEntity") {
            const model = this.data.model;
            this.labelTemplate = `Authorised - ${model.ev_Code} - ${model.version} - ${model.productname}`;
            this.label = this.labelTemplate;
        }
        if (this.constructor.name === "_DevelopmentProductAutoUploadEntity") {
            const model = this.data.model;
            this.labelTemplate = `Development - ${model.ev_Code} - ${model.version} ${model.productname?" - " + model.productname:model.productothername?" - " +model.productothername:''}`;
            this.label = this.labelTemplate;
        }
    }

    reloadEntity() {
        this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'success', detail: 'Updating entity', life: environment.errorElapsedTime });
        let service: any
        switch (this.service) {
            case ServiceEnum.MedicinalProducts:
                service = this.ioc!.get(MedicinalproductsService);
        }
        this.isLoading = true;
        this.children?.splice(0, this.children.length);
        service.loadEntity(this.autoUploadEntityName, this.code)
            .subscribe({
                next: (data: any) => {
                    const jsonData = data;
                    if (jsonData) {
                        this.data = new this.entityClass!(this.ioc!, jsonData);
                        this.datasource = jsonData;
                        this.postLoadEntity(jsonData);
                        this.refreshLabels();
                        this.isLoaded = true;
                        this.ioc!.get(MedicinalproductsService).loading.next(false);
                        this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'success', detail: 'Entity updated', life: environment.errorElapsedTime });
                    } else {
                        this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'warn', detail: 'No results found', life: environment.warningElapsedTime });
                    }
                },
                error: (error: any) => {
                    this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'error', detail: 'Error found', life: environment.errorElapsedTime });
                }
            });
    }

}